import { render, staticRenderFns } from "./MaterialDelete.vue?vue&type=template&id=7bf24b93&"
import script from "./MaterialDelete.vue?vue&type=script&lang=js&"
export * from "./MaterialDelete.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDelete.vue?vue&type=style&index=0&id=7bf24b93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports